/**
 * Determines paddings, font sizes, button sizes, etc.
 */
export type ModalSizingVariant = 'sm' | 'md';

export const paddingValues = {
    sm: { px: 3, py: 2.5 },
    md: { px: 4, py: 3 },
} as const satisfies Record<ModalSizingVariant, { px: number; py: number }>;

export const modalHeaderClassName = 'UphealModalHeader';
